export default "__VITE_ASSET__4fc2a787__"